import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as LandRegistryActions from '../_actions/landRegistry';
import { LandRegistry } from '../_models';

export interface LandRegistryState extends EntityState<LandRegistry> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<LandRegistry> = createEntityAdapter<LandRegistry>();

const initialState: LandRegistryState = adapter.getInitialState({
  loading: false,
  error: null,
});

const landRegistryReducer = createReducer(
  initialState,

  on(LandRegistryActions.loadLandRegistries, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LandRegistryActions.loadLandRegistriesSuccess, (state, { landRegistries }) =>
    adapter.setAll(landRegistries, { ...state, loading: false })
  ),

  on(LandRegistryActions.loadLandRegistriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LandRegistryActions.addLandRegistrySuccess, (state, { landRegistry }) =>
    adapter.addOne(landRegistry, state)
  ),

  on(LandRegistryActions.updateLandRegistrySuccess, (state, { landRegistry }) =>
    adapter.upsertOne(landRegistry, state)
  ),

  on(LandRegistryActions.deleteLandRegistrySuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    LandRegistryActions.addLandRegistryFailure,
    LandRegistryActions.updateLandRegistryFailure,
    LandRegistryActions.deleteLandRegistryFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: LandRegistryState | undefined, action: Action) {
  return landRegistryReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
